import { Link, Typography } from '@cmg/design-system';
import { identitySelectors } from '@cmg/e2e-selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { PageGridSection } from '../../../../design-system/body-sections/PageGridSection';
import { IdentityPageContent } from '../../../../design-system/IdentityPageContent';
import { selectAccount } from '../../../account-detail/shared/ducks';
import { LoginSettingsSection } from './grid-content/LoginSettingsSection';

export type RouteParams = { accountSubdomain?: string };

export const AccountSecurityRouteComponent: React.FC = () => {
  const account = useSelector(selectAccount);
  const { accountSubdomain } = useParams<RouteParams>();

  if (!account) {
    return null;
  }

  return (
    <div data-testid={identitySelectors.accountDetail.accountSecurityScreen.testId}>
      <IdentityPageContent
        gridContent={
          <React.Fragment>
            <LoginSettingsSection
              accountSubdomain={accountSubdomain}
              localLoginEnabled={account.localLoginEnabled}
              identityProviders={account.identityProviders}
            />
            <PageGridSection
              title="IP Whitelist"
              content={
                <Typography>
                  Please contact{' '}
                  <Link href="mailto:support@cmgx.io" component="a">
                    support@cmgx.io
                  </Link>
                  .
                </Typography>
              }
            />
          </React.Fragment>
        }
      />
    </div>
  );
};

export default AccountSecurityRouteComponent;
